// Module
var code = "You should return to the place you consider home... ";
// Exports
module.exports = code;